import { templateContLocaleId, type TemplateContLocaleId } from "./TemplateContLocale";
import { templateSchemasId, type TemplateSchemasId } from "./TemplateSchemas";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for templ_cont_loc_yjs_update */
export type TemplContLocYjsUpdateId = string & { __flavor: "TemplContLocYjsUpdateId" };

/**
 * Represents the table public.templ_cont_loc_yjs_update
 * @uniqueConstraints {"templ_cont_loc_yjs_update_pkey":{"name":"templ_cont_loc_yjs_update_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"idx_template_content_locale_yjs_update":{"name":"idx_template_content_locale_yjs_update","isPrimary":false,"isUnique":false,"columns":[{"name":"template_content_locale_id","definition":"template_content_locale_id","predicate":null}]},"idx_template_schema_yjs_update":{"name":"idx_template_schema_yjs_update","isPrimary":false,"isUnique":false,"columns":[{"name":"template_schema_id","definition":"template_schema_id","predicate":null}]}}
 */
export default interface TemplContLocYjsUpdateTable {
  id: ColumnType<
    TemplContLocYjsUpdateId,
    TemplContLocYjsUpdateId | undefined,
    TemplContLocYjsUpdateId
  >;

  templateContentLocaleId: ColumnType<
    TemplateContLocaleId | null,
    TemplateContLocaleId | null,
    TemplateContLocaleId | null
  >;

  update: ColumnType<unknown, unknown, unknown>;

  stateVector: ColumnType<unknown, unknown, unknown>;

  templateSchemaId: ColumnType<
    TemplateSchemasId | null,
    TemplateSchemasId | null,
    TemplateSchemasId | null
  >;

  previewId: ColumnType<string | null, string | null, string | null>;
}

export type TemplContLocYjsUpdate = Selectable<TemplContLocYjsUpdateTable>;

export type NewTemplContLocYjsUpdate = Insertable<TemplContLocYjsUpdateTable>;

export type TemplContLocYjsUpdateUpdate = Updateable<TemplContLocYjsUpdateTable>;

export const templContLocYjsUpdateId = z.number() as unknown as z.Schema<TemplContLocYjsUpdateId>;

export const templContLocYjsUpdate = z.object({
  id: templContLocYjsUpdateId,
  templateContentLocaleId: templateContLocaleId.nullable(),
  update: z.unknown(),
  stateVector: z.unknown(),
  templateSchemaId: templateSchemasId.nullable(),
  previewId: z.string().nullable(),
});

export const templContLocYjsUpdateInitializer = z.object({
  id: templContLocYjsUpdateId.optional(),
  templateContentLocaleId: templateContLocaleId.optional().nullable(),
  update: z.unknown(),
  stateVector: z.unknown(),
  templateSchemaId: templateSchemasId.optional().nullable(),
  previewId: z.string().optional().nullable(),
});

export const templContLocYjsUpdateMutator = z.object({
  id: templContLocYjsUpdateId.optional(),
  templateContentLocaleId: templateContLocaleId.optional().nullable(),
  update: z.unknown().optional(),
  stateVector: z.unknown().optional(),
  templateSchemaId: templateSchemasId.optional().nullable(),
  previewId: z.string().optional().nullable(),
});

// ── constraints for TemplContLocYjsUpdate ─────────────────────────────────
export const TemplContLocYjsUpdateConstraints = {
  templ_cont_loc_yjs_update_pkey: {
    name: "templ_cont_loc_yjs_update_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  idx_template_content_locale_yjs_update: {
    name: "idx_template_content_locale_yjs_update",
    isPrimary: false,
    isUnique: false,
    columns: [
      {
        name: "template_content_locale_id",
        definition: "template_content_locale_id",
        predicate: null,
      },
    ],
  },
  idx_template_schema_yjs_update: {
    name: "idx_template_schema_yjs_update",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "template_schema_id", definition: "template_schema_id", predicate: null }],
  },
} as const;
export type TemplContLocYjsUpdateConstraintsType = typeof TemplContLocYjsUpdateConstraints;
